// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LpvgK2Fj78yRroWqOi9S{display:flex}@media print{.LpvgK2Fj78yRroWqOi9S{display:block}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `LpvgK2Fj78yRroWqOi9S`
};
module.exports = ___CSS_LOADER_EXPORT___;
